var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3143 0H8.67918C3.88571 0 0 3.88571 0 8.67918V28.7935H6.67429C8.29388 28.7935 9.6 27.4808 9.6 25.8678V22.1257C9.6 20.5061 10.9127 19.2 12.5257 19.2H16.2678C17.8873 19.2 19.1935 20.5127 19.1935 22.1257V35.4678C19.1935 37.0873 20.5061 38.3935 22.1192 38.3935H25.8612C27.4808 38.3935 28.7869 37.0808 28.7869 35.4678V12.5257C28.7869 10.9061 30.0996 9.6 31.7127 9.6H35.4547C37.0743 9.6 38.3804 10.9127 38.3804 12.5257V25.8678C38.3804 27.4873 39.6931 28.7935 41.3061 28.7935H47.9804V8.67918C47.9804 3.88571 44.0947 0 39.3012 0H39.3143Z",
    fill: "#253D30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0678 28.8H41.3257C39.7061 28.8 38.4 27.4873 38.4 25.8743V12.5257C38.4 10.9061 37.0873 9.59998 35.4743 9.59998H31.7322C30.1127 9.59998 28.8065 10.9126 28.8065 12.5257V35.4677C28.8065 37.0873 27.4939 38.3934 25.8808 38.3934H22.1388C20.5192 38.3934 19.2131 37.0808 19.2131 35.4677V22.1257C19.2131 20.5061 17.9004 19.2 16.2873 19.2H12.5453C10.9257 19.2 9.61959 20.5126 9.61959 22.1257V25.8677C9.61959 27.4873 8.30694 28.7934 6.69388 28.7934H0V39.3077C0 44.1012 3.88571 47.9869 8.67918 47.9869H39.3143C44.1078 47.9869 47.9935 44.1012 47.9935 39.3077V28.7934H45.0678V28.8Z",
    fill: "#09A868"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ff1ffbb79ef9cc28dfa2840187f82c51.svg";
export { ForwardRef as ReactComponent };